import { values } from "lodash"
import $fetch from "../$fetch"
import Filter from "../filter/Filter"
import app from "app.controller"

window.Filter = Filter

var sort_options = {
  article_nr: true,
  created   : true,
  des       : true,
  sort      : true,
  price     : true
}

export default class Products {
  constructor( shop, config ) {
    this.config = config
    this.shop = shop
    this.filters = {}
    this.filters.category = new Filter().category( true )
  }
  
  search( value, { filter, sort, count, start, page = 1, dir = "desc" } = {} ) {
    count = count || this.shop.settings.get( "pageSize" )
    start = start || (page - 1) * count
    console.log( `search::`, value, filter )
    return this.query( {
      value,
      filter,
      sort,
      count,
      start,
      dir
    } )
  }
  
  list( product_ids ) {
    if ( !Array.isArray( product_ids ) ) throw("list() expects an Array as its' sole argument")
    // /shop/rest/data/productlist?list=[100003,100004]
    let url = this.config.API + "data/productlist?list=%5B" + product_ids.toString() + "%5D" + "&lang=" + app._currentLanguage
    return $fetch( url, {
      mode       : "cors",
      credentials: "include"
    } )
      .then( response => response.list )
      .then( response => {
        response = response.map( productData => new this.shop.ProductModel( productData ) )
        response = response.filter( p => !p.invalid )
        return response
      } )
      .catch()
  }
  
  /**
   * api.products.fromCategory(49) -> Get Products from category 49
   * @param value
   * @param sort
   * @param count
   * @param start
   * @returns {type[]}
   */
  fromCategory( value, { query = "%%", sort, page = 1, count = 6, dir = "desc" } = {} ) {
    console.log( `search::fromCategory`, value )
    let start = (page - 1) * count
    return this.query( {
      value : "%%",
      filter: this.filters.category.query( value ),
      sort,
      count,
      start,
      dir
    } )
  }
  
  /**
   * [search description]
   * @param  {[type]} value  [description]
   * @param  {[type]} filter [description]
   * @param  {String} sort   [description]
   * @param  {Number} count  [description]
   * @param  {Number} start  [description]
   * @param dir
   * @return {[type]}                [description]
   */
  query( { value, filter, sort = "article_nr", count = 6, start = 0, dir = "desc" } ) {
    
    if ( filter !== false ) {
      if ( !filter || !filter.extra ) {
        let salesFilter = {}
        salesFilter.extra = "false"
        salesFilter.field = "articletype"
        salesFilter.not = "1"
        
        salesFilter.op = "equals"
        salesFilter.value = "02"
        
        filter = [
          filter,
          salesFilter
        ]
      }
    }
    console.log( `filter`, filter )
    
    if ( !value && !filter ) console.warn( "Invalid search term: ", value )
    if ( value.length < 3 && value !== "%%" ) {
      return Promise.resolve( false )
    }
    if ( !(sort in sort_options) ) {
      console.warn( "Unkown sort mode. Use", sort_options )
    }
    // '?filter=%5B%7B"cats"%3A%5B"83"%5D%7D%5D&start=0&count=6&sort=article_nr&dir=asc&?lang=de'
    let filterSegment = ""
    if ( filter ) {
      if ( !Array.isArray( filter ) ) filter = [filter]
      let f = JSON.stringify( filter )
      /*console.log("filterF",  f)
      f = f.slice(0, f.indexOf('}'));
      if(f.indexOf('028000000') !== -1){
        f = f.slice(0, f.indexOf(']'));
        f = f + ',"023000000"]}]';
      }*/
      console.log("filter", f)
      filterSegment = "&filter=" + encodeURIComponent( f )
      console.log("filterSegment: ", filterSegment);
    }
    
    let valueSegment = ""
    if ( value ) {
      valueSegment = "value=" + value
      console.log("valueSegment: ", valueSegment);
    }
    
    let url = this.config.API + "data/search?" + valueSegment + filterSegment + "&start=" + start + "&count=" + count + "&sort=" + sort + "&dir=" + dir +
      "&lang=" + app._currentLanguage
      console.log("URL: ",url);
      console.log("valueSegment: ",valueSegment);
      console.log("filterSegment: ",filterSegment);
      console.log("start: ",start);
      console.log("count: ",count);
      console.log("sort: ",sort);
      console.log("dir: ",dir);
    return $fetch( url, {
      mode       : "cors",
      credentials: "include"
    } )
      .then( response => {
        console.log( `api::search`, response )
        response.products = response.result.map( productData => new this.shop.ProductModel( productData ) )
        response.products = response.products.filter( p => !p.invalid )
        return response
      } )
      .catch( ( err ) => {
        console.warn( "Failed search:", err )
        return {}
      } )
    
  }
}




// WEBPACK FOOTER //
// ./src/sdk/Products/Products.js